import { useRef as k, useLayoutEffect as A } from "react";
const b = (t, E, v, s, f) => {
  const l = k(null), p = k(null), y = k(null);
  return A(() => {
    t == null || t.setAttribute("data-ref", "eGridHeader"), t == null || t.setAttribute("aria-label", f);
    const w = (n) => {
      var u;
      const o = n.target, c = (u = o == null ? void 0 : o.getAttribute) == null ? void 0 : u.call(o, "data-ref");
      (n.key === "Enter" || n.key === " ") && (c === "eMoreMenu" || c === "eFilterButton") && n.stopImmediatePropagation();
    }, R = (n) => {
      var u;
      const o = document.activeElement, c = (u = o == null ? void 0 : o.getAttribute) == null ? void 0 : u.call(o, "data-ref");
      n.key === "Tab" && (n.stopImmediatePropagation(), c === "eGridHeader" && (n.preventDefault(), s != null && s.length && y.current ? y.current.focus() : E && l.current ? l.current.focus() : v && p.current && p.current.focus()));
    };
    if (t == null || t.addEventListener("keydown", w, { capture: !0 }), t == null || t.addEventListener("keydown", R), t && f) {
      const n = t.closest('[role="treegrid"], [role="grid"]');
      n && n.setAttribute("aria-label", f);
    }
    return () => {
      t == null || t.removeEventListener("keydown", w, { capture: !0 }), t == null || t.removeEventListener("keydown", R);
    };
  }, [t, E, v, s, f]), {
    filterButtonRef: l,
    sortButtonRef: p,
    moreMenuRef: y
  };
};
export {
  b as useBaseHeaderEGridSetup
};
//# sourceMappingURL=index.es5659.js.map
